import { Component, h, State, Prop } from '@stencil/core';
import ChatSDK from 'test-iso-chat-sdk';
import '../../stories/Components/SearchableList/SearchableList.js'
import {drawerDialogService} from '../../stories/Components/Dialog-Drawer/dialog-drawer.js'

@Component({
  tag: 'forward-memebers',
  styleUrl: '',
  shadow: true,
})
export class MemberAdd {
  @State() nonBlockedContacts: any[] = [];
  @State() skip: number = 0;
  @State() isNoContactsFound: boolean = false;
   @State() hasMore: any = false;
    @State() isLoading: boolean = false;
    @State() paginationLoading: boolean = false;
  @Prop() dialogData: any ={};
  
  async componentDidLoad() {
    await this.getForwardMessageMemberList(null,0); 
  }
  getForwardMessageMemberList = async (searchTag?: string, skip?: number) => {
    if (skip === 0) {
      this.isLoading = true;
      this.nonBlockedContacts = [];
    }

    if (skip >= 20) {
      this.paginationLoading = true;
    }    
    this.hasMore = true;
    try {
      if (searchTag !== undefined && skip === undefined) {
        this.nonBlockedContacts = [];
        this.skip = 0;
      }

      const paramsForNonBlockedContacts = {
        sort: 1,
        limit: 20,
        skip: skip || this.skip,
        context: 'new_chat',
      };

      if (searchTag?.trim()) {
        // @ts-ignore
        paramsForNonBlockedContacts.searchTag = searchTag;
      }

      const res = await ChatSDK.getInstance().user.getUserNonblock(paramsForNonBlockedContacts);

      if (!res?.users || res.users.length === 0) {
        this.isNoContactsFound = searchTag?.trim() ? true : false; // Only show no results if there was a search
      } else {
        this.isNoContactsFound = false;
        const uniqueContacts = res?.users?.filter(newContact => !this.nonBlockedContacts.some(existingContact => existingContact.userId === newContact.userId));
        this.nonBlockedContacts = [...this.nonBlockedContacts, ...uniqueContacts];
        this.skip += res.users.length;
      }
      if (res?.users?.length < paramsForNonBlockedContacts.limit) {
        this.hasMore = false;
      }
    } catch (error) {
      if (error?.status === 404 || error?.statusCode === 404) {
        this.hasMore = false;
      }
      if ((error?.status === 404 || error?.statusCode === 404) && searchTag != null) {
        this.nonBlockedContacts = [];
      }
    } finally {
      this.isLoading = false;
      this.paginationLoading = false;
    }
  }

  postMessageForward = async (messageBody: any, userIds?: string[], conversationIds?: string[], attachments?: any, customType?:string) => {
    try {
      const requestBody: any = {
        messageType: 1,
        showInConversation: true,
        encrypted: false,
        body: messageBody,
        attachments: attachments,
        deviceId: this.dialogData.deviceId,
        customType:customType
      };

      if (userIds?.length > 0) {
        requestBody.userIds = userIds;
      }

      if (conversationIds?.length > 0) {
        requestBody.conversationIds = conversationIds;
      }

      await ChatSDK.getInstance().message.postMessagesForward(requestBody);
    } catch (error) {
      console.error('Error forwarding the message', error);
    }finally{
      drawerDialogService.closeDialog('forward-memebers')
    }
  };
  async sendMessageHandler(selectedContacts:any,dialogData:any) {
    const allUserIds: string[] = [];
    const allConversationIds: string[] = [];

    selectedContacts?.forEach(contact => {
      const { userId, contactConversationId } = contact;

      if (userId) allUserIds.push(userId);
      if (contactConversationId) allConversationIds.push(contactConversationId);
    });
    if (dialogData?.message) {
      const parsedMessageBody = typeof dialogData?.message?.body === 'string' ? dialogData.message?.body : dialogData.message?.body?.messageBody;
      if (allUserIds?.length > 0 || allConversationIds?.length > 0) {
        await this.postMessageForward(
          parsedMessageBody,
          allUserIds?.length > 0 ? allUserIds : null,
          allConversationIds?.length > 0 ? allConversationIds : null,
          dialogData.message?.attachments,
          dialogData.message?.customType
        );
      }

    }
  }
  render() {
    return (
      <searchable-list
                fontSize="16px"
                label="Forward message to"
                conversationList={this.dialogData.conversationList}
                contactList={this.nonBlockedContacts}
                getForwardMessageMemberList={this.getForwardMessageMemberList}
                isLoading={this.isLoading}
                hasMore={this.hasMore}
                skip={this.skip}
                paginationLoading={this.paginationLoading}
                onSend={(selectedContacts)=>this.sendMessageHandler(selectedContacts,this.dialogData)}
              ></searchable-list>
    )}
}